export default __webpack_public_path__ + "static/media/rmcm03.54d800f1.png";